import {
  ADD_PAGE_EXPERIENCE,
  GET_PAGE_EXPERIENCE,
  UPDATE_PAGE_EXPERIENCE,
  EXPERIENCE_MANAGEMENT_DATA_ADMIN,
  EXPERIENCE_MANAGEMENT_ARCHIVED_DATA_ADMIN
} from "../../types";

const initialState = {
  pages: [],
  experiences: [],
  archivedExps: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_PAGE_EXPERIENCE:
      return {
        ...state,
        pages: [...state?.pages, action.payload],
      };
    case GET_PAGE_EXPERIENCE:
      return {
        ...state,
        pages: action.payload,
      };
    case UPDATE_PAGE_EXPERIENCE:
      if (state?.pages?.length) {
        let _data = state?.pages || [];
        for (let index = 0; index < _data.length; index++) {
          if (_data[index]?._id === action?.payload?._id)
            _data[index] = action.payload;
        }
        return {
          ...state,
          pages: _data,
        };
      } else {
        return {
          ...state,
          pages: [...state?.pages, action.payload],
        };
      }
    case EXPERIENCE_MANAGEMENT_DATA_ADMIN:
      return {
        ...state,
        experiences: action.payload,
      };
    case EXPERIENCE_MANAGEMENT_ARCHIVED_DATA_ADMIN:
      return {
        ...state,
        archivedExps: action.payload,
      };
    default:
      return state;
  }
}
